


export function useCharacterCount(chars?: string) {
  if (chars) {
    return chars.length > 0 ?
      chars.length
      :
      0;
  }

  return 0;
}
